// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

if (new Date().getTime() >= new Date('2020/04/04') && new Date().getTime() <= new Date('2020/04/05')) {
  $('html').css('filter', 'grayscale(1)')
}




// WEBPACK FOOTER //
// ./src/main.js